import { HttpErrorResponse, HttpHeaders, HttpRequest } from "@angular/common/http";

function headersToObject(headers: HttpHeaders): Record<string, string> {
    const result: Record<string, string> = {};
    if (headers) {
        headers.keys()?.forEach(key => {
            result[key] = headers.get(key) || '';
        });
    }
    return result;
}

export class MkgError extends HttpErrorResponse {
    body: HttpRequest<any>['body'];
    method?: HttpRequest<any>['method'];
    urlWithParams?: HttpRequest<any>['urlWithParams'];
    rawHeaders?: object | null;
    attempts?: number;
    constructor({
        error,
        body,
        method,
        urlWithParams,
        headers,
        attempts
     }: {
            error: HttpErrorResponse,
            body?: HttpRequest<any>['body'],
            method?: HttpRequest<any>['method'],
            urlWithParams?: HttpRequest<any>['urlWithParams'],
            headers?: HttpRequest<any>['headers'],
            attempts?: number
        }) {
        super(error)
        this.body = body;
        this.method = method;
        this.urlWithParams = urlWithParams;
        this.rawHeaders = headersToObject(headers);
        this.attempts = attempts;
    }
}
